import React from 'react';

export default function UserDirectoryToolbar({
  filters,
  filterOptions,
  variant = 'complete',
  loading,
  onFilterChange,
  onSearchChange,
  onApply,
  onReset,
}) {
  const planOptions = filterOptions?.planTiers ?? [{ value: '', label: 'Any plan' }];

  const circleOptions = filterOptions?.circleStatuses || [
    { value: '', label: 'Any status' },
    { value: 'complete', label: 'Complete' },
    { value: 'pending', label: 'Pending' },
    { value: 'incomplete', label: 'Incomplete' },
    { value: 'no_circle', label: 'No Circle' },
  ];

  const verificationOptions = filterOptions?.verificationLevels || [
    { value: '', label: 'Any' },
    { value: 'fully_verified', label: 'Fully verified' },
    { value: 'unverified', label: 'Unverified' },
  ];

  const showPlanFilter = variant === 'complete';

  return (
    <div className="cm-toolbar udt-single-line">
      <div className="cm-toolbar-start">
        {showPlanFilter && (
          <select
            className="cm-filter-select"
            name="plan"
            value={filters.plan}
            onChange={onFilterChange}
            aria-label="Plan"
          >
            {planOptions.map((opt, i) => (
              <option key={opt.tierId ?? `${opt.value || 'any'}-${i}`} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        )}

        <select
          className="cm-filter-select"
          name="trustedCircle"
          value={filters.trustedCircle}
          onChange={onFilterChange}
          aria-label="Trusted Circle"
        >
          {circleOptions.map((opt) => (
            <option key={opt.value ?? 'any'} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        <select
          className="cm-filter-select"
          name="verification"
          value={filters.verification}
          onChange={onFilterChange}
          aria-label="Verification"
        >
          {verificationOptions.map((opt) => (
            <option key={opt.value ?? 'any'} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        <select
          className="cm-filter-select"
          name="onboardingStatus"
          value={filters.onboardingStatus ?? 'complete'}
          onChange={onFilterChange}
          aria-label="User Status"
        >
          <option value="complete">Active Users</option>
          <option value="incomplete">Onboarding Progress</option>
          <option value="">All Users</option>
        </select>

                <select
          className="cm-filter-select"
          name="sort"
          value={filters.sort || 'newest'}
          onChange={onFilterChange}
          aria-label="Sort By"
        >
          <option value="newest">Created: Newest First</option>
          <option value="oldest">Created: Oldest First</option>
          <option value="last_login_desc">Last Login: Recent First</option>
          <option value="last_login_asc">Last Login: Oldest First</option>
        </select>

        <div className="cm-search-wrap">
          <i className="fas fa-magnifying-glass" aria-hidden />
          <input
            type="text"
            className="cm-search-input"
            placeholder="Search name, email, or mobile…"
            value={filters.search}
            onChange={onSearchChange}
            onKeyDown={(e) => e.key === 'Enter' && onApply()}
          />
        </div>
      </div>
      <div className="cm-toolbar-end">
        <button type="button" className="cm-apply-btn" onClick={onApply} disabled={loading}>
          <i className="fas fa-check" /> Apply
        </button>
        <button type="button" className="cm-reset-link" onClick={onReset}>
          Reset filters
        </button>
      </div>
    </div>
  );
}
